import { render, staticRenderFns } from "./liuliangshouzhimoxing.vue?vue&type=template&id=d4a03e40&scoped=true&"
import script from "./liuliangshouzhimoxing.vue?vue&type=script&lang=js&"
export * from "./liuliangshouzhimoxing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a03e40",
  null
  
)

export default component.exports